<div class="spinner" [ngClass]="size"></div>
